import { ProtobufClient } from 'api/protobuf/protobuf-client';
import { goBackendApi } from 'hooks/api/httpApi';
import {
    PackageProvidersFeaturesResponse,
    PackageProvidersFeaturesResponseSchema,
} from '../../../pb/responses/v1/package_providers_features_response_pb';

export const fetchPackagePointsProvidersFeatures = async (
    providerIds: number[]
): Promise<PackageProvidersFeaturesResponse> => {
    const pbClient = new ProtobufClient(goBackendApi());
    return pbClient
        .getRequest(
            PackageProvidersFeaturesResponseSchema,
            `/api/v1/package-provider-features?package_provider_ids=${providerIds.join(',')}`
        )
        .then((res) => res);
};
